<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-video</v-icon>
        <span class="m-l-5">Video</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <div class="container">
      <v-autocomplete
        class="m-t-5 no-drag"
        v-model="prompt.path"
        :items="items"
        item-text="allText"
        item-value="path"
        dense
        hide-details
        @change="videoChange"
      >
        <template slot="selection" slot-scope="{ item }">
          {{ subString(item.path, 70) }}
        </template>
        <template slot="item" slot-scope="{ item }">
          <v-tooltip top :open-delay="700">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="float-right width100 font-size-sub margin8px m-r-5"
              >
                <div class="dropdown-text">
                  {{ subString(item.description, 70) }}
                </div>
                <div class="dropdown-title">
                  {{ subString(item.name, 50) }}
                </div>
              </div>
            </template>
            <span class="font-size-body">
              {{ item.path }}<br />{{ item.description }}
            </span>
          </v-tooltip>
        </template>
      </v-autocomplete>
      <v-text-field
        v-model="prompt.previewImagePath"
        placeholder="Enter thumbnail url"
        hide-details
        class="m-t-5"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PayloadVideoUrl',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array
  },
  data() {
    return {
      previewImagePath: ''
    }
  },
  watch: {
    prompt: {
      deep: true,
      immediate: true,
      handler(val) {}
    }
  },
  methods: {
    subString(text, length) {
      if (text.length < length) return text
      return `${text.substr(0, length)}...`
    },

    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    },

    videoChange() {
      const item = _.find(this.items, { path: this.prompt.path })
      this.prompt.previewImagePath = item.previewImagePath || ''
      this.previewImagePath = item ? item.previewImagePath : ''
    }
  }
}
</script>

<style scoped lang="scss">
.font-size-body {
  max-width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  word-wrap: break-word;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.dropdown-title {
  font-size: 14px;
}

.dropdown-text {
  font-size: 11px;
  color: $text-color;
}

.margin8px {
  margin: 8px 0;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.box-description {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.container {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}
</style>
